import React from 'react';

/**
 * Обёртка для recharts: явная высота в px (ResponsiveContainer с height="100%"
 * часто даёт 0×0 в flex/overflow-auto layout → белый блок вместо графика).
 */
export default function ChartPanel({ height = 320, className = '', children }) {
  return (
    <div
      className={`w-full min-w-0 ${className}`}
      style={{ height, minHeight: height }}
    >
      {children}
    </div>
  );
}

export class ChartErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('[ChartErrorBoundary]', error?.message, info?.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="flex items-center justify-center h-full text-sm text-red-600 bg-red-50 rounded-lg border border-red-100 p-4">
          Не удалось отобразить график{this.props.label ? `: ${this.props.label}` : ''}. Обновите страницу.
        </div>
      );
    }
    return this.props.children;
  }
}
